import { Button, CircularProgress, TextField } from '@mui/material'
import React, { useCallback } from 'react'
import { useAuth } from '../../../../context/AuthContext'
import { useAlert } from '../../../../context/AlertContext'
import { FlexContainer } from '../../../../styles/common/FlexBox'
import { useForm } from '../../../../hooks/useForm'
import useUTMParams from '../../../../hooks/useUTMParams'
import usePromoveLogin from '../../../../hooks/usePromoveLogin'
import { formatCPF, validateForm } from '../../../../utils/Gerais/userUtils'

const INITIAL_FORM_DATA = { cpf: '' };
const CPF_FIELDS = [{ name: 'cpf' }];

const Promove = ({ incentiveId, handleClose, onSuccess }) => {

  const { auth } = useAuth();
  const { showAlert } = useAlert();
  const { utmSource, utmCampaign } = useUTMParams();
  const { loginPromove, loading } = usePromoveLogin();

  const validateCpf = useCallback((data) => validateForm(data, CPF_FIELDS), []);

  const { formData, handleChange, validate, error: formError } = useForm(
    INITIAL_FORM_DATA,
    validateCpf
  );

  const handleLogin = async () => {
    if (!validate()) return;

    const cpf = formData.cpf.replace(/\D/g, '');
    const { token, error } = await loginPromove(cpf, utmSource, utmCampaign, incentiveId);

    if (!token) {
      showAlert(error || 'Erro no login, verifique seu CPF!', 'error');
      return;
    }

    const authenticated = await auth(+incentiveId);

    if (!authenticated) {
      showAlert('Sua conta não tem acesso a este clube.', 'error');
      return;
    }

    showAlert('Login realizado com sucesso!', 'success');
    if (handleClose) handleClose();
    if (onSuccess) onSuccess();
  };

  return (
    <FlexContainer direction="column" justify="center" align="center" gap="1.5rem" margin="0 0 1rem 0" >

      <div>
        Para acessar o Clube Promove, informe o CPF.
      </div>

      <TextField
        id="cpf"
        name="cpf"
        label="CPF"
        variant="outlined"
        sx={{
          width: '100%',
          '& .MuiInputBase-input': {
            height: '1em'
          }
        }}
        value={formatCPF(formData.cpf)}
        onChange={handleChange}
        error={!!formError}
        helperText={formError}
      />

      {loading ? (
        <CircularProgress color="primary" />
      ) : (
        <Button className="btn-primary-2" variant="outlined" onClick={handleLogin}>Entrar</Button>
      )}
    </FlexContainer>
  )
}

export default Promove
